<template>
    <v-container>
        <v-dialog v-model="dialog" max-width="800px" persistent>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                            color="primary"
                            dark
                            class="mx-2"
                            v-bind="attrs"
                            v-on="on"
                            v-if="canEdit"
                            >เบิกวัสดุสิ้นเปลือง</v-btn>
                        </template>
            <v-card outlined>
                <v-card-title ><strong>เบิกวัสดุสิ้นเปลือง</strong></v-card-title>
                <v-divider class="ma-2"></v-divider>
                <div class="pl-5 pr-5">
                    <v-form ref="formDetail" lazy-validation>
                    <v-row>
                        <v-col>
                            <v-autocomplete
                                :rules="[rules.requiredConsumable]"
                                v-model="selectedConsumable"
                                autofocus
                                return-object
                                :items="dropdownData"
                                item-text="consumableDisplay"
                                item-value="consumableCode"
                                outlined 
                                placeholder="พิมพ์รหัส หรือ ชื่อวัสดุสิ้นเปลือง"
                                label="วัสดุสิ้นเปลือง">
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                     <v-row v-if="isSelected">
                         <v-col cols="3">
                            <DatePicker 
                                ref="withdrawDate"
                                label="วันที่เบิก" 
                                @dateFormatted="setWithdrawDate" >
                            </DatePicker>
                        </v-col>
                        <v-col><v-text-field outlined placeholder=" " :rules="[rules.requiredMaxNumber(editedItem.stockRemain)]" label="จำนวน" maxlength="7" v-model="editedItem.qty"></v-text-field></v-col>
                        <v-col><v-text-field type="number" disabled outlined placeholder=" " :rules="[rules.requiredNumber]" label="ราคา/หน่วย" v-model="editedItem.unitPrice"></v-text-field></v-col>
                        <v-col><v-text-field  disabled outlined placeholder=" " label="หน่วย" v-model="editedItem.unitOfSize"></v-text-field></v-col>
                        <v-col><v-text-field  disabled outlined placeholder=" " label="คงเหลือในสต็อก" v-model="editedItem.stockRemainDisplay"></v-text-field></v-col>
                    </v-row>
                    <v-row v-if="editedItem.consumableCode != ''"> 
                        <v-col>
                                        <v-autocomplete
                                            :rules="[rules.required]"
                                            v-model="editedItem.withdrawBy"
                                            :items="empList"
                                            item-text="name"
                                            item-value="name"
                                            outlined 
                                            placeholder="พิมพ์รหัส หรือ ชื่อช่างที่เบิก"
                                            label="ชื่อช่างที่เบิก">
                                        </v-autocomplete>
                                    </v-col>
                                    <!--
                        <v-col><v-text-field outlined placeholder=" " label="ช่างที่เบิก"  v-model="editedItem.withdrawBy"></v-text-field></v-col>
                        -->
                    </v-row>
                    </v-form> 
                </div>
                <v-card-actions class="text-right">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="saveDetail">บันทึก</v-btn>
                    <v-btn color="primary" @click="closeDialog"> ยกเลิก</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import DatePicker from '@/components/Shared/DatePicker'
import rules from '@/assets/js/rules.js'
import {listDropdownConsumableType, listTechnicial} from '@/api/common/dropdown-api.js'
import numeral from 'numeral'
import dialog from '@/assets/js/dialog.js'

export default {
    name: 'DlgWithDrawConsumable',
    components: {
        DatePicker
    },
    computed: {
        isSelected() {
            return Object.entries(this.selectedConsumable).length > 0;
        },
        dropdownData() {
            if (this.items.length == 0 || this.isEditMode) return this.consumableList;
            let retList = [];
            this.consumableList.forEach(e => {
                /*
                let filter = this.items.filter(o => o.consumableCode == e.consumableCode);
                if (filter && filter.length > 0) return;
                */
                retList.push(e);
            });
            return retList;
        }
    },
    watch: {
        dialog(val) {
            if (!this.isEditMode && val) {
                this.listDropdown();
            }
        },
        selectedConsumable(val) {
            if (!val || !this.isEditMode) {
                this.clearData();
            }
            if (this.isEditMode) return;
            this.editedItem.consumableCode = val.consumableCode;
            this.editedItem.consumableName = val.consumableName;
            this.editedItem.consumableType = val.consumableType;
            this.editedItem.consumableTypeText = val.consumableTypeText;
            this.editedItem.unitPrice = val.unitPrice;
            this.editedItem.unitOfSize = val.unitOfSize;
            this.editedItem.stockRemainDisplay = numeral(val.stockRemain).format('0.00');
            this.editedItem.stockRemain = val.stockRemain;
        }
    },
    props: ["canEdit", "items", "branchCode"],
    data: () => ({
        dialog: false,
        rules: rules,
        isEditMode: false,
        empList: [],
        consumableList: [],
        selectedConsumable: {},
        editedItem: {
            consumableCode: '',
            consumableName: '',
            consumableType: '',
            qty: 1,
            withdrawBy: '',
            withdrawDate: '',
            total: 0,
            stockRemain: 0
        }
    }),
    methods: {
        listDropdown() {
            listDropdownConsumableType('CS', this.branchCode, true).then(rs => {
                this.consumableList = rs;
            });
            listTechnicial(this.branchCode).then(rs => {
            this.empList = rs;
        });
        },
        setWithdrawDate(val) {
            this.editedItem.withdrawDate = val;
        },
        clearData() {
            this.editedItem = Object.assign({}, {});
            this.editedItem.consumableCode = '';
        },
        closeDialog() {
            this.clearData();
            this.selectedConsumable = {};
            this.isEditMode = false;
            this.dialog = false;
            this.$emit("onCloseDialog");
        },
        saveDetail() {
            if (!this.$refs.formDetail.validate()) {
                return;
            }

            if (this.editedItem.qty > this.editedItem.stockRemain) {
                dialog.warn("กรุณากรอกจำนวนที่เบิก ไม่เกิน จำนวนในสต็อก");
                return;
            }

            this.$emit("onSaveConsumable", this.editedItem);
            this.closeDialog();
        },
        show(item) {
            this.isEditMode = true;
            if (item != undefined) {
                this.selectedConsumable = this.consumableList.filter(e => e.consumableCode == item.consumableCode)[0];
                this.editedItem = Object.assign(this.editedItem, item);
            }
            
            this.dialog = true;
        }
    }
}
</script>